import type { IconData } from '@stacksjs/iconify-core'

export const pushchair: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M445.057 345.134L464 274.1V232c-8.136-93.993-87.933-168-184-168h-32v168H132.158l-17.844-78.768A32.155 32.155 0 0 0 83.038 128H16v32h67.038l40.475 178.67A80 80 0 1 0 224 416q0-4.05-.4-8h104.8q-.395 3.948-.4 8a80 80 0 1 0 117.057-70.866M280 96c78.411 0 143.145 59.678 151.164 136H280ZM144 464a48 48 0 1 1 48-48a48.055 48.055 0 0 1-48 48m194.763-88H213.237a80.17 80.17 0 0 0-57.316-39.108L139.408 264H432v5.9l-17.7 66.368a81 81 0 0 0-6.3-.271A80.03 80.03 0 0 0 338.763 376M408 464a48 48 0 1 1 48-48a48.055 48.055 0 0 1-48 48\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default pushchair
